export default {
  setDataHistory(state, { payload }) {
    state.dataHistory = payload.data.list;
  },
  setTotalData(state, { payload }) {
    state.totalData = parseInt(payload.data.count_data, 10);
    state.totalPage = parseInt(payload.data.total_page, 10);
  },
  setOnUpload(state, onUpload) {
    state.onUpload = onUpload;
  },
  setOnDownloadResult(state, onDownloadResult) {
    state.onDownloadResult = onDownloadResult;
  },
  setUploadProgress(state, uploadProgress) {
    state.uploadProgress = uploadProgress;
  },
  setFlashErrorMessage(state, payload) {
    state.flashErrorMessage = payload;
    state.flashError = payload !== '';
  },
  clearData(state) {
    state.dataHistory = [];
    state.totalData = 0;
  },
  clearErrors(state) {
    state.errors = [];
  },
  setErrors(state, payload) {
    state.errors = payload;
  },

  setLoading(state, loading) {
    state.loading = loading;
  },
  setCancelation(state, payload) {
    state.requestData = payload;
  },
};
